require('./media/js/underscore.es5.js');
require('./media/js/underscore.string.es5.js');
require('./media/js/underscore.mixins.es5.js');
require('./media/js/widgets/widget.es5.js');
require('./media/js/widgets/dropdowns/base.es5.js');
require('./media/js/widgets/dropdowns/styled_labels.es5.js');
require('./media/js/widgets/dropdowns/checkbox.es5.js');
require('./media/js/widgets/dropdowns/rounded.es5.js');
require('./media/js/widgets/dropdowns/rounded_checkbox.es5.js');
require('./media/plugins/date.es5.js');
require('./media/js/country_codes.es5.js');
require('./media/js/utility.js');
